module.exports = __webpack_public_path__ + "static/media/ProximaNovaSoft-Medium.dee324af.otf";